<template>
  <div class="gray-bg content">
    <div class="login-content">
      <p class="title">益体康 <span class="dot"></span> 项目经理</p>
      <div class="form-content">
        <el-input type="text" @keyup.enter.native="login" v-model="username" placeholder="用户名" prefix-icon="el-icon-user" clearable></el-input>
        <el-input type="password" @keyup.enter.native="login" v-model="pwd" placeholder="密码" prefix-icon="el-icon-lock" clearable></el-input>
        <el-checkbox v-model="checked" style="width:280px;text-align: left;color:#333333;">记住用户名和密码</el-checkbox>
        <el-button type="primary" @click="login" :disabled="loginDisabled">登录</el-button>
        <p class="version-text">版本号 V2.7.1</p>
      </div>
    </div>
    <p class="footer">
      <small>Copyright © 2001-至今 益体康（北京）科技有限公司
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="padding-left: 10px;">京ICP备09007401号-12</a>
        <img src="../assets/img/gongan.png" style="padding-left: 10px;">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036751" target="_blank">京公网安备 11010802036751号</a>
      </small>
    </p>
    <p class="download"> <a href="https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/pdfdownloader_beta1.0.0.3.exe">报告批量下载工具 v1.0.0.3</a></p>
  </div>
</template>

<script>
  import ApiService from "../service/ApiService";
  import pub from "../service/public";
  import md5 from "js-md5";
  import appConfig from "../../static/config.json";

  export default {
    name: "Login",
    data() {
      return {
        username: "",
        pwd: "",
        checked: false,
        loginDisabled:false,
      }
    },
    created() {
      this.$cookies.set(pub.token.token_key, '');//token authorization  post传值需要的
      this.$cookies.set(pub.token.token_role_name, '');
      this.$cookies.set(pub.token.token_usrname, '');//用户名
      this.$cookies.set(pub.token.refresh_key, '');//用来刷新authorization

      let name = this.$cookies.get("save_usrname_wf");
      let pwd = this.$cookies.get("save_pwd_wf");
      if (name != '' || pwd != '') {
        this.username = name;
        this.pwd = pwd;
        this.checked = true;
      }
    },
    methods: {
      login() {
        let that = this;
        this.username = this.username.trim();
        this.pwd = this.pwd.trim();
        if (that.username == "") {
          this.$message({
            showClose: true,
            message: '用户名不能为空',
            type: 'warning',
            duration: 1500
          });
        } else if (that.pwd == "") {
          that.$message({
            showClose: true,
            message: '密码不能为空',
            type: 'warning',
            duration: 1500
          });
        } else {
          that.handleLogin();
        }

      },
      // 处理登录请求
      handleLogin() {
        this.loginDisabled = true;
        const params = {
          page: { number: 0, limit: 1 },
          keyWord: [],
          parms: {
            strUsrName: this.username,
            strUsrPwd: md5(this.pwd),
            strClientUuid:'A0F9GQHU6YE3D5AG'
          }
        };

        ApiService.UsrLogin(params)
          .then(res => {
            if (res.code === pub.backCode.SUCCESS) {
              this.handleLoginSuccess(res);
            } else {
              pub.analysisReturnCode(res, null);
            }
          })
          .catch(error => {
            console.error('登录错误：', error);
            pub.tip('登录失败，请检查网络连接', 'error');
          })
          .finally(() => {
            this.loginDisabled = false;
          });
      },
      // 处理登录成功
      handleLoginSuccess(res) {
        const userInfo = res.dic;

        // 存储 token 和用户信息
        this.$cookies.set(pub.token.token_key, userInfo.strAuthorization);
        this.$cookies.set(pub.token.refresh_key, userInfo.strRefreshToken);
        localStorage.setItem('UL_WF_UsrInfo', JSON.stringify(userInfo));
        this.$cookies.set('save_usrname_wf', this.username);

        // 记录当前前端版本号，用于后续版本校验
        if (appConfig && appConfig.VERSION) {
          localStorage.setItem('UL_WF_VERSION', appConfig.VERSION);
        }

        // 记住密码
        if (this.checked) {
        
          this.$cookies.set('save_pwd_wf', this.pwd);
        } else {
          this.$cookies.remove('save_pwd_wf');
        }

        // 加载系统枚举常量（失败不阻止登录）
        this.loadSystemConst();
      },
      // 加载系统枚举常量
      loadSystemConst() {
        let params = {
          page: { number: 0, limit: 9999 },
          keyWord: [],
          parms:{}
        };
        ApiService.GetConst(params).then(res => {
          if (res.code === pub.backCode.SUCCESS && res.data) {
            // 存储枚举常量到 localStorage
            localStorage.setItem('UL_WF_Const', JSON.stringify(res.data));
            // 跳转到记录列表页
            this.$router.push('/recordList');
          } else {
            console.warn('获取系统枚举常量失败:', res.message || res.msg);
            // 枚举加载失败不影响登录，使用默认值
          }
        }).catch(error => {
          console.error('获取枚举常量错误：', error);
          // 枚举加载失败不影响登录，使用默认值
        });
      },
      resizeHeightHandler() {
        let htmlHeight = document.documentElement.clientHeight || document.body.clientHeight;
        document.querySelector('.content').style.minHeight = (htmlHeight) + 'px'//给内容撑开，让页面更加规整
      },

    },
    beforeMount() {
      window.addEventListener('resize', this.resizeHeightHandler);//响应式
    },
    destroyed() {
      window.removeEventListener('resize', this.resizeHeightHandler)
    },
    mounted() {
      this.resizeHeightHandler();
    },
  }
</script>

<style scoped="scoped" lang="scss">
 .content{
   width: 100%;
   height: 100%;
   background: url("../assets/img/bj.jpg") no-repeat center;
   background-size: cover;
   min-width: 1360px;
   text-align: center;
   position: relative;
 }
  .login-content {
    position: absolute;
    width: 420px;
    min-height: 360px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.18);
    padding: 32px 40px 28px;
    box-sizing: border-box;
  }
  .login-content .title {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 24px;
    text-align: center;
    color: #333333;
    font-weight: normal;
    margin-top: 0;
  }
  .login-content .title .dot{
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background: #666666;
    position: relative;
    top: -3px;
  }
  .login-content .form-content{
    width: 300px;
    padding-top: 10px;
    margin: 0 auto;
  }
  .login-content .form-content .el-input {
    margin-bottom: 20px;
    width: 280px;
  }
  >>>.el-input__inner,>>>.el-input::-webkit-scrollbar-corner,>>>.el-input::-webkit-scrollbar-track-piece{
    background: none !important;
    border-radius: 20px;
    color: #333333;
  }
  .login-content .form-content .el-button {
    width: 280px;
    margin-top: 18px;
    margin-bottom: 10px;
    border-radius: 20px;
    background: rgb(37,171,227);
    border-color: rgb(37,171,227);
  }
  .login-content .form-content .el-button:hover {
    background: rgb(47,181,237);
    border-color: rgb(47,181,237);
  }
  .login-content .form-content .version-text{
    margin: 0;
    padding-top: 4px;
    font-size: 12px;
    color: #999999;
    text-align: center;
  }
  >>>.el-checkbox__input.is-checked+.el-checkbox__label{
    color: rgb(37,171,227);
  }
  >>>.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background: rgb(37,171,227);
    color: rgb(37,171,227);
    border-color: rgb(37,171,227);
  }
  .footer,.download{
    min-width: 1360px;
    position: fixed;
    bottom: 40px;
    color: #ffffff;
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    a{
      color: #ffffff;
    }
  }
  .download{
    bottom: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue